import { setDate, setMessage, setNumber } from './localizers';
import { setDefaultPopupContainerClass as setPopupClass } from './widget-helpers';

export const setDateLocalizer = setDate;
export const setNumberLocalizer = setNumber;
export const setMessageLocalizer = setMessage;
export const setDefaultPopupContainerClass = setPopupClass;

export function setLocalizers({ date, number, message }) {
  if (date) {
    setDateLocalizer(date);
  }

  if (number) {
    setNumberLocalizer(number);
  }

  if (message) {
    setMessageLocalizer(message);
  }
}

export default {
  setDateLocalizer,
  setNumberLocalizer,
  setMessageLocalizer,
  setLocalizers,
  setDefaultPopupContainerClass
};
